module.exports = __webpack_public_path__ + "static/media/austrian-dev-coop.80602239.jpg";